export const ROUTES = {
  ALLTRANSACTION: '/allTransaction',
  ALLCREDIT: '/allcredit',
  ALLDEBIT: '/alldebit',
  AAJOURNEY: '/AAJOURNEY',
  DASHBOARD: '/dashboard',
  LANDING: '/landing',
  BUDGET: '/budget',
  GOALDETAILS: '/goalDetails',
  ERROR: '/error',
  ETBCUSTOMERSCREEN: '/etbcustomerScreen',
  HOLDINGS: '/holdings',
  JFS_BANK_ACCOUNT_DETAIL: '/bank-account-detail',
  JFS_ALL_TRANSACTIONS: '/all-transactions',
  JFS_CATEGORY_TRANSACTIONS: '/category-transactions',
  JFS_TRANSACTION_HISTORY: '/transaction-history',
  STOCKS_ETFS: '/stocks-etfs',
  MUTUAL_FUNDS: '/mutual-funds',
  JFS_FAQ: '/faq',
  JFS_WELCOME: '/welcome',
  JFS_ACCOUNT_DETAIL: '/account-detail',
  JFS_NUDGE_CARDS: '/nudge-cards',
  JFS_NUDGES: '/jfs-nudges',
  JFS_DATA_FAILED: '/data-failed',
  AU_WELCOME: '/au-welcome',
  AU_SPENDS: '/au-spends',
  AU_STOCKS: '/au-stocks',
  AU_NUDGES: '/au-nudges',
  AU_FDRD: '/au-fdrd',
  AU_EPF: '/au-epf',
  AU_EPF_PASSBOOK: '/au-epf-passbook',
  AU_EPF_ALL_EMPLOYERS: '/au-epf-all-employers',
  AU_EPF_ACCOUNT_DETAILS: '/au-epf-account-details',
  AU_MUTUAL_FUNDS: '/au-mutual-funds',
};
